import styled from 'styled-components';

export const CustomWorkflowStep = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    width: 100%;

    > div {
        width: 100%;
    }

    div[slot='footer'] {
        position: sticky;
        padding-right: 40px;
    }
`;
